/**
 * Created by Reda on 19.07.2026
 */

cleverapps.SkinManager.SKINS.dragonia3_expedition = {
    bundle: "expedition_dragonia3",

    slots: {
        ...cleverapps.SkinManager.SKINS.rose_energy.slots,
        workerSkin: function () {
            const expedition = cleverapps.meta.selectedLocationId();
            return cleverapps.Spine.hasSkin(expedition, bundles.mineable.jsons.worker_json) ? expedition : undefined;
        },

        gameAudio: function () {
            return bundles.expedition_dragonia3.urls.dragonia3_music;
        },

        unitOnCell: function () {
            return cleverapps.styles.UnitOnCellExpedition;
        },

        gameSceneBg: function () {
            return {
                horizontalPattern: bundles.expedition_dragonia3.urls.dragonia3_bg,
                parallax: true
            };
        },

        merge_wand_png: bundles.menubar.frames.dragonia3_merge_wand_png,

        wand_icon_png: bundles.buttons_inlined_icons_dragonia3.frames.dragonia3_wand_icon_png,
        feed_icon_png: bundles.buttons_inlined_icons_dragonia3.frames.dragonia3_feed_icon_png,

        expedition_buildpass_icon_json: bundles.sidebar.jsons.dragonia3_expedition_buildpass_icon_json,
        whirlwind: bundles.fog_animations.jsons.dragonia3_whirlwind,

        snail_feast_icon_json: bundles.sidebar.jsons.dragonia3_snail_feast_icon_json,
        snailhouse_offer_json: bundles.sidebar.jsons.dragonia3_snailhouse_offer_json,
        snailhouse_offer_extrabar_icon: bundles.extrabar && bundles.extrabar.jsons.dragonia3_snailhouse_offer_extrabar_icon,

        snail_feast_icon: bundles.reward_icons_merge_dragonia3.frames.dragonia_snail_feast_icon,
        reward_wand_png: bundles.reward_icons_merge_dragonia3.frames.dragonia_reward_wand_png,
        reward_wand_small_png: bundles.reward_icons_merge_dragonia3.frames.dragonia_reward_wand_small_png,

        landmarkGuideOptions: function () {
            return {
                name: "dragonia3_product_guidewindow",
                bundle: bundles.dragonia3_product_guidewindow,
                title: "LandmarkGuideWindow.title"
            };
        },

        fog_disappear_effect: function () {
            return bundles.fog_dragonia3.urls.open_effect;
        } 
    }
};
